import { isNonEmptyString } from './utils/smart-string';

type MaybeToolWithNamespace = {
  name?: unknown;
  namespace?: unknown;
};

export function toolQualifiedName(
  name: string | undefined,
  namespace?: string,
): string | undefined {
  if (!isNonEmptyString(name)) {
    return undefined;
  }
  if (isNonEmptyString(namespace)) {
    return `${namespace}.${name}`;
  }
  return name;
}

export function getToolCallDisplayName(
  toolCall: MaybeToolWithNamespace,
): string | undefined {
  return toolDisplayName(
    isNonEmptyString(toolCall.name) ? toolCall.name : undefined,
    isNonEmptyString(toolCall.namespace) ? toolCall.namespace : undefined,
  );
}

export function toolDisplayName(
  name: string | undefined,
  namespace?: string,
): string | undefined {
  if (!isNonEmptyString(name)) {
    return undefined;
  }

  if (!isNonEmptyString(namespace) || namespace === name) {
    return name;
  }

  return `${namespace}.${name}`;
}
